import { render, staticRenderFns } from "./SetLink.vue?vue&type=template&id=0a9b0f9e&scoped=true"
import script from "./SetLink.vue?vue&type=script&lang=js"
export * from "./SetLink.vue?vue&type=script&lang=js"
import style0 from "./SetLink.vue?vue&type=style&index=0&id=0a9b0f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b0f9e",
  null
  
)

export default component.exports